import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

export const requiresEmailVerification = (user) => Boolean(
  user &&
  user.email &&
  !user.emailVerified &&
  user.providerData?.some((provider) => provider.providerId === 'password')
);

export const sendAccountVerificationEmail = async (user, isFrench = false) => {
  if (!user?.sendEmailVerification) {
    throw new Error('No signed-in user is available for email verification.');
  }

  firebase.auth().languageCode = isFrench ? 'fr' : 'en';

  return user.sendEmailVerification({
    url: `${window.location.origin}/login?verified=1`,
    handleCodeInApp: false,
  });
};

export const refreshEmailVerification = async (user) => {
  if (!user?.reload) {
    throw new Error('No signed-in user is available to refresh.');
  }

  await user.reload();
  const refreshedUser = firebase.auth().currentUser || user;

  if (refreshedUser.emailVerified && refreshedUser.getIdToken) {
    await refreshedUser.getIdToken(true);
  }

  return refreshedUser;
};
